import React from 'react';
import {
  Card, Avatar, Tooltip, Popconfirm, message, Typography,
} from 'antd';
import {
  EditOutlined, DownloadOutlined, LinkOutlined, DeleteOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;

const FORMAT_STYLES = {
  json: { bg: '#1677ff', label: 'JSON' },
  xml: { bg: '#fa8c16', label: 'XML' },
  yaml: { bg: '#52c41a', label: 'YAML' },
};

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}

function ConfigCard({
  item, onOpen, onDownload, onDelete,
}) {
  const fmt = FORMAT_STYLES[item.format] || { bg: '#8c8c8c', label: item.format };
  const publicUrl = `${window.location.origin}/configs/${item.filename}`;

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      message.success('URL скопирован');
    } catch (e) {
      message.error('Не удалось скопировать URL');
    }
  };

  return (
    <Card
      hoverable
      bodyStyle={{ padding: 20 }}
      actions={[
        <Tooltip title="Открыть" key="open">
          <EditOutlined onClick={() => onOpen(item)} />
        </Tooltip>,
        <Tooltip title="Скачать" key="download">
          <DownloadOutlined onClick={() => onDownload(item)} />
        </Tooltip>,
        <Tooltip title="Копировать URL" key="copy">
          <LinkOutlined onClick={handleCopyUrl} />
        </Tooltip>,
        <Popconfirm
          key="delete"
          title={`Удалить ${item.filename}?`}
          okText="Да"
          cancelText="Отмена"
          onConfirm={() => onDelete(item)}
        >
          <DeleteOutlined style={{ color: '#ff4d4f' }} />
        </Popconfirm>,
      ]}
    >
      <Card.Meta
        avatar={(
          <Avatar
            shape="square"
            size={48}
            style={{
              backgroundColor: fmt.bg,
              color: '#fff',
              fontWeight: 600,
              fontSize: 12,
              borderRadius: 8,
            }}
          >
            {fmt.label}
          </Avatar>
        )}
        title={(
          <Text
            ellipsis={{ tooltip: item.filename }}
            style={{ fontSize: 15, fontWeight: 500 }}
          >
            {item.filename}
          </Text>
        )}
        description={(
          <Text type="secondary" style={{ fontSize: 12 }}>
            {`${formatSize(item.size)} · ${dayjs(item.mtime).format('DD.MM.YYYY HH:mm')}`}
          </Text>
        )}
      />
    </Card>
  );
}

export default ConfigCard;
